import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { Button, FacilityIcon } from '@lt/components';
import cn from 'classnames';

import { i18n } from '@lt/localization';
import Nbsp from '../../../../../../components/Nbsp';

class Facilities extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isShowing: false,
    };

    this.toggleText = this.toggleText.bind(this);
  }

  toggleText() {
    const { isShowing } = this.state;
    this.setState({ isShowing: !isShowing });
  }

  render() {
    const { items, baseCls, isMobile } = this.props;
    const { isShowing } = this.state;

    const extraFacilities = items.filter((item) => item.extra === true);

    const facilitiesCls = `${baseCls}-facilities`;
    const facilitiesItemCls = `${baseCls}-facilities__item`;
    const extraFacilitiesCls = cn(facilitiesCls, {
      [`${facilitiesCls}--with-text`]: isMobile ? isShowing : true,
    });

    return (
      !isEmpty(items) && (
        <>
          <ul className={facilitiesCls}>
            {items
              .filter((item) => item.extra === false)
              .map(({ original_name: name, group_identifier: icon }) => (
                <li className={facilitiesItemCls} key={name}>
                  <FacilityIcon
                    key={name}
                    className={facilitiesItemCls}
                    type={icon}
                    name={name}
                  />
                </li>
              ))}
          </ul>

          {isMobile && !isEmpty(extraFacilities) && (
            <p className={`${baseCls}-item__more`}>
              {i18n.t('checkout.extraRooms.facilities')} ·
              <Nbsp />
              <Button
                onClick={this.toggleText}
                className="lt-link"
                type="button"
                functional
              >
                {i18n.t('checkout.extraRooms.more')}
              </Button>
            </p>
          )}

          <ul className={extraFacilitiesCls}>
            {extraFacilities.map(
              ({ original_name: name, group_identifier: icon }) => (
                <li className={facilitiesItemCls} key={name}>
                  {!isMobile && (
                    <span className={`${facilitiesCls}__icon-prefix`}>+</span>
                  )}

                  <FacilityIcon type={icon} />

                  <span title={name} className={`${facilitiesCls}__text`}>
                    {name}
                  </span>
                </li>
              ),
            )}
          </ul>
        </>
      )
    );
  }
}

Facilities.defaultProps = {
  items: [],
};

Facilities.propTypes = {
  baseCls: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      original_name: PropTypes.string.isRequired,
      group_identifier: PropTypes.string.isRequired,
      extra: PropTypes.bool.isRequired,
    }),
  ),
};

export default Facilities;
